import type { CheckboxData } from 'src/components/molecules/CheckboxGroup/CheckboxGroup';
import type { RadioButtonData } from 'src/components/molecules/RadioButtonGroup/RadioButtonGroup';

export const INITIAL_PRODUCT_CATEGORIES: CheckboxData[] = [
  { labelText: 'Baby and child', value: 'BABY_AND_CHILD' },
  { labelText: 'Clothing', value: 'CLOTHING' },
  { labelText: 'Experiences', value: 'EXPERIENCES' },
  { labelText: 'Fashion accessories', value: 'FASHION_ACCESSORIES' },
  { labelText: 'Food and drink', value: 'FOOD_AND_DRINK' },
  { labelText: 'Hobbies, Leisure and Crafting', value: 'HOBBIES_LEISURE_AND_CRAFTING' },
  { labelText: 'Electronics and Tech Accessories', value: 'ELECTRONICS_AND_TECH_ACCESSORIES' },
  { labelText: 'Health and beauty', value: 'HEALTH_AND_BEAUTY' },
  { labelText: 'Home, Art and Outdoors', value: 'HOME_ART_AND_OUTDOORS' },
  { labelText: 'Jewellery', value: 'JEWELLERY' },
  { labelText: 'Stationery and Party Supplies', value: 'STATIONERY_AND_PARTY_SUPPLIES' },
  { labelText: 'Toys and Games', value: 'TOYS_AND_GAMES' },
  { labelText: 'Pet Supplies', value: 'PET_SUPPLIES' },
];

export const YES_NO_DOCUMENTATIONS_OPTIONS: RadioButtonData<string>[] = [
  { labelText: 'Yes, I have the relevant documentation', value: 'TRUE' },
  { labelText: "No, I don't have the relevant documentation", value: 'FALSE' },
  { labelText: "I don't require documentation to sell my products", value: 'UNKNOWN' },
];
